import { Component, OnInit, ViewChild, ɵConsole } from '@angular/core';
import { FormBuilder, Validators, ValidatorFn } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { IMyDpOptions } from 'mydatepicker';
import * as moment from 'moment';
import { Location } from '@angular/common';
import { DatatableService } from '../../../shared/services/datatable.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { AlteracaoUsuarioBackofficeService } from './alteracao-usuario-backoffice.service';
import { EncriptyUtilService } from '../../../shared/services/encripty-util.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationsService } from 'angular2-notifications';
import { DateUtilService } from '../../../shared/services/date-util.service';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'ngx-alteracao-usuario-backoffice',
  templateUrl: './alteracao-usuario-backoffice.component.html',
  styleUrls: ['./alteracao-usuario-backoffice.component.scss']
})
export class AlteracaoUsuarioBackofficeComponent implements OnInit {

  public formAlteracaoUserBack = null;
  public id = null;
  public dataExpiracao = null;
  public tipo = null;
  public grupoUser = [];
  public checked = false;
  public confirmarSenha = null;
  public senha = null;
  public grupo = null;
  
  public yesterday = new Date((new Date()).valueOf() - 1000*60*60*24);

  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    showClearDateBtn: false,
    openSelectorOnInputClick: true,
    showTodayBtn: false,
    allowSelectionOnlyInCurrentMonth: false,
    dayLabels: { su: "Dom", mo: "Seg", tu: "Ter", we: "Qua", th: "Qui", fr: "Sex", sa: "Sab" },
    monthLabels: { 1: "Jan", 2: "Fev", 3: "Mar", 4: "Abr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Set", 10: "Out", 11: "Nov", 12: "Dez" },
    firstDayOfWeek: "su",
    disableUntil: { year: this.yesterday.getFullYear(), month: this.yesterday.getMonth() + 1, day: this.yesterday.getDate() },
  };

  constructor(
    private formBuilder: FormBuilder,
    private service: AlteracaoUsuarioBackofficeService,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private encriptyService: EncriptyUtilService,
    private notificationService: NotificationsService,
    private dateUtilService: DateUtilService,
    private spinnerService: NgxSpinnerService,
  ) {

    this.grupoUser = [];

    this.activatedRoute.queryParams.subscribe(register => {

      this.id = this.encriptyService.decriptyBySecretKey(register.id);

      this.service.buscaUser(this.id, null, (response => {

        this.formAlteracaoUserBack.controls['nomeUsuario'].setValue(response.nome);
        this.formAlteracaoUserBack.controls['loginUsuario'].setValue(response.login);
        this.formAlteracaoUserBack.controls['email'].setValue(response.email);
        this.formAlteracaoUserBack.controls['status'].setValue(response.status);
        let dataExpiracao: any = {
          date: {
            year: new Date(response.dataExpiracao).getFullYear(),
            month: new Date(response.dataExpiracao).getMonth() + 1,
            day: new Date(response.dataExpiracao).getDate() + 1,
          },
        };
        this.formAlteracaoUserBack.controls['dataExpiracao'].setValue(dataExpiracao);

        if (response.gruposPermissao[0] != null) {
          this.grupo = response.gruposPermissao[0];
          if (this.grupo == "ADMIN") {
            this.formAlteracaoUserBack.controls['admin'].setValue(this.grupo);
            this.grupoUser.push(this.grupo)
          }
          if (this.grupo == "CALL_CENTER") {
            this.formAlteracaoUserBack.controls['callCenter'].setValue(this.grupo);
            this.grupoUser.push(this.grupo)
          }
          if (this.grupo == "POS_VENDA") {
            this.formAlteracaoUserBack.controls['posVendas'].setValue(this.grupo);
            this.grupoUser.push(this.grupo)
          }
          if (this.grupo == "OPERACAO") {
            this.formAlteracaoUserBack.controls['operacao'].setValue(this.grupo);
            this.grupoUser.push(this.grupo)
          }
        }
        if (response.gruposPermissao[1] != null) {
          this.grupo = response.gruposPermissao[1];
          if (this.grupo == "ADMIN") {
            this.formAlteracaoUserBack.controls['admin'].setValue(this.grupo);
            this.grupoUser.push(this.grupo)
          }
          if (this.grupo == "CALL_CENTER") {
            this.formAlteracaoUserBack.controls['callCenter'].setValue(this.grupo);
            this.grupoUser.push(this.grupo)
          }
          if (this.grupo == "POS_VENDA") {
            this.formAlteracaoUserBack.controls['posVendas'].setValue(this.grupo);
            this.grupoUser.push(this.grupo)
          }
          if (this.grupo == "OPERACAO") {
            this.formAlteracaoUserBack.controls['operacao'].setValue(this.grupo);
            this.grupoUser.push(this.grupo)
          }
        }
        if (response.gruposPermissao[2] != null) {
          this.grupo = response.gruposPermissao[2];
          if (this.grupo == "ADMIN") {
            this.formAlteracaoUserBack.controls['admin'].setValue(this.grupo);
            this.grupoUser.push(this.grupo)
          }
          if (this.grupo == "CALL_CENTER") {
            this.formAlteracaoUserBack.controls['callCenter'].setValue(this.grupo);
            this.grupoUser.push(this.grupo)
          }
          if (this.grupo == "POS_VENDA") {
            this.formAlteracaoUserBack.controls['posVendas'].setValue(this.grupo);
            this.grupoUser.push(this.grupo)
          }
          if (this.grupo == "OPERACAO") {
            this.formAlteracaoUserBack.controls['operacao'].setValue(this.grupo);
            this.grupoUser.push(this.grupo)
          }
        }
        if (response.gruposPermissao[3] != null) {
          this.grupo = response.gruposPermissao[3];
          if (this.grupo == "ADMIN") {
            this.formAlteracaoUserBack.controls['admin'].setValue(this.grupo);
            this.grupoUser.push(this.grupo)
          }
          if (this.grupo == "CALL_CENTER") {
            this.formAlteracaoUserBack.controls['callCenter'].setValue(this.grupo);
            this.grupoUser.push(this.grupo)
          }
          if (this.grupo == "POS_VENDA") {
            this.formAlteracaoUserBack.controls['posVendas'].setValue(this.grupo);
            this.grupoUser.push(this.grupo)
          }
          if (this.grupo == "OPERACAO") {
            this.formAlteracaoUserBack.controls['operacao'].setValue(this.grupo);
            this.grupoUser.push(this.grupo)
          }
        }


      }), error => {

        null;

      });
    });

    this.tipo = [
      {
        status: 'ATIVO',
        descricao: 'ATIVO'
      },
      {
        status: 'INATIVO',
        descricao: 'INATIVO'
      },

    ];

  }

  ngOnInit() {

    this.formAlteracaoUserBack = this.formBuilder.group({
      nomeUsuario: [null],
      loginUsuario: [null],
      email: [null],
      senha: [null],
      confirmaSenha: [null],
      status: [null],
      dataExpiracao: [null],
      admin: [null],
      callCenter: [null],
      posVendas: [null],
      operacao: [null],


    });

  }

  togglePaymentTypesFields(data) {

    if (data.checked == true) {

      this.grupoUser.push(data.value);
      var arr = this.grupoUser;
      var novaArr = arr.filter((este, i) => arr.indexOf(este) === i);
      this.grupoUser = novaArr;
    } else {
      this.grupoUser = this.grupoUser.filter(grupo => grupo != data.value)
      var arr = this.grupoUser;
      var novaArr = arr.filter((este, i) => arr.indexOf(este) === i);
      this.grupoUser = novaArr;
    }

  }

  validarSenhas = (data): ValidatorFn => {

    this.confirmarSenha = data.confirmaSenha;

    if (this.formAlteracaoUserBack) {

      this.senha = this.formAlteracaoUserBack.get('senha').value

    }

    if (this.senha != this.confirmarSenha) {

      this.notificationService.warn('Senha não confere');

    }

    return null;
  }

  acessar() {

    this.formAlteracaoUserBack.getRawValue()

  }

  limpaCampos() {

    this.formAlteracaoUserBack.controls['confirmaSenha'].setValue(null);

  }

  gotoEditar(data) {

    if (data.dataExpiracao != null) {

      this.dateUtilService.datepickerTransformDate(data.dataExpiracao, 'YYYY-MM-DD')
      let dataExpiracao = this.getDateTimestamp(data.dataExpiracao);
      data.dataExpiracao = dataExpiracao;

    }

    let register = {

      confirmaSenha: data.confirmaSenha,
      dataExpiracao: data.dataExpiracao,
      email: data.email,
      gruposPermissoes: this.grupoUser,
      login: data.loginUsuario,
      nome: data.nomeUsuario,
      senha: data.senha,
      status: data.status,

    }

    this.spinnerService.show();

    this.service.userBackoffice(
      this.id, register,
      (response) => {
        this.spinnerService.hide();
        this.notificationService.success('Usuário Backoffice alterado com sucesso!');
        this.limparForm();
      }, (error) => {
        this.spinnerService.hide();
        this.notificationService.error(error.message);
      });


  }

  limparForm() {

    this.formAlteracaoUserBack = this.formBuilder.group({
      nomeUsuario: [null],
      loginUsuario: [null],
      email: [null],
      senha: [null],
      confirmaSenha: [null],
      status: [null],
      dataExpiracao: [null],
      admin: [null],
      callCenter: [null],
      posVendas: [null],
      operacao: [null],


    });


  }

  getDateTimestamp(data) {

    let dataReturn = null;
    if ('jsdate' in data) {
      dataReturn = new Date(data.jsdate)
      dataReturn = moment(dataReturn).format('YYYY-MM-DD');
    } else {
      dataReturn = new Date(data.date['year'], data.date['month'] - 1, data.date['day']).getTime();
      dataReturn = moment(dataReturn).format('YYYY-MM-DD');
    }

    return dataReturn;
  }

  previousPage() {

    this.location.back();

  }

  gotoVoltar() {

    this.location.back();

  }

}
